import ButtonLarge from 'common/ButtonLarge';
import CreateText from 'common/CreateText';
import styled from 'styled-components';

import React from 'react';

const ContainerDiv = styled.div`
    background: ${(props) => props.theme.colorBackground};
    width: 100%;
    height: 100%;
    min-height: 400px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .button {
        padding: 0px 60px;
    }
    .text {
        margin: 22px 0px;
    }
`;
const EmptyOfficeStaff = ({ togglePopup }) => {
    return (
        <ContainerDiv>
            <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M22.0016 42.1665C10.8639 42.1665 1.83496 33.1375 1.83496 21.9998C1.83496 10.8621 10.8639 1.83313 22.0016 1.83313C33.1394 1.83313 42.1683 10.8621 42.1683 21.9998C42.1683 33.1375 33.1394 42.1665 22.0016 42.1665ZM35.5669 31.3957C37.4172 28.7293 38.5016 25.4912 38.5016 21.9998C38.5016 12.8871 31.1143 5.4998 22.0016 5.4998C12.8889 5.4998 5.50163 12.8871 5.50163 21.9998C5.50163 25.4906 6.58567 28.7282 8.43547 31.3944C10.4991 28.6695 15.3474 27.4999 22.0007 27.4999C28.6551 27.4999 33.5038 28.6699 35.5669 31.3957ZM32.9361 34.3567C32.4001 32.427 28.5452 31.1666 22.0007 31.1666C15.4577 31.1666 11.603 32.4264 11.0656 34.3554C13.977 36.9342 17.8065 38.4998 22.0016 38.4998C26.196 38.4998 30.0249 36.9347 32.9361 34.3567ZM22.0013 10.9998C17.563 10.9998 14.668 14.2187 14.668 18.3332C14.668 24.6167 17.8962 27.4998 22.0013 27.4998C26.0678 27.4998 29.3346 24.7125 29.3346 18.6998C29.3346 14.5227 26.4273 10.9998 22.0013 10.9998ZM18.3343 18.3332C18.3343 22.4935 19.8344 23.8332 22.001 23.8332C24.1601 23.8332 25.6676 22.5469 25.6676 18.6999C25.6676 16.409 24.2297 14.6665 22.001 14.6665C19.6795 14.6665 18.3343 16.1622 18.3343 18.3332Z"
                        fill="#C4C4C4"
                    />
                </svg>
            </div>

            <CreateText className="text">
                Set up your Office Staff & Team Access
            </CreateText>

            <div style={{ 
                textAlign: 'center', 
                maxWidth: '500px', 
                marginBottom: '32px',
                color: '#666',
                fontSize: '16px',
                lineHeight: '1.5',
                fontFamily: 'Poppins, sans-serif'
            }}>
                Add team members who can access and manage your business profile, appointments, and patient information. 
                Assign admin or general access levels to control what each staff member can view and edit.
            </div>

            <div>
                <ButtonLarge className="button" onClick={togglePopup}>
                    Add a Staff Member
                </ButtonLarge>
            </div>
        </ContainerDiv>
    );
};

export default EmptyOfficeStaff;
